/**
 * @generated SignedSource<<3c6f40ec289ec5e2ad6d4c17007f94d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationCategory = "UPGRADE" | "SUPPORT" | "INCIDENT" | "EVENT" | "OTHER" | "%future added value";
export type UpdateNotificationInput = {
  clientMutationId?: string | null;
  notificationId: string;
  body?: string | null;
  category?: NotificationCategory | null;
  publishedAt?: string | null;
  title?: string | null;
};
export type NotificationEditPage_Mutation$variables = {
  input: UpdateNotificationInput;
};
export type NotificationEditPage_MutationVariables = NotificationEditPage_Mutation$variables;
export type NotificationEditPage_Mutation$data = {
  readonly updateNotification: {
    readonly notification: {
      readonly id: string;
      readonly title: string;
      readonly body: string | null;
      readonly category: NotificationCategory | null;
      readonly publishedAt: string;
      readonly slug: string;
    };
  } | null;
};
export type NotificationEditPage_MutationResponse = NotificationEditPage_Mutation$data;
export type NotificationEditPage_Mutation = {
  variables: NotificationEditPage_MutationVariables;
  response: NotificationEditPage_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNotificationPayload",
    "kind": "LinkedField",
    "name": "updateNotification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Notification",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationEditPage_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationEditPage_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "862182358b1ba70884f4fd9b506e69e9",
    "id": null,
    "metadata": {},
    "name": "NotificationEditPage_Mutation",
    "operationKind": "mutation",
    "text": "mutation NotificationEditPage_Mutation(\n  $input: UpdateNotificationInput!\n) {\n  updateNotification(input: $input) {\n    notification {\n      id\n      title\n      body\n      category\n      publishedAt\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "198edae504a37fbe41695dbdc675c99f";

export default node;
